<template>
  <div class="wxpay-box-container" v-if="open">
    <div class="wxpay-box">
      <div class="wxpay-box-header">
        <div class="wxpay-box-title">{{method ? "支付宝支付" : "微信支付"}}</div>
        <button type="button" aria-label="Close" class="wxpay-box-header_headerbtn" @click="close">
          <i class="wxpay-box-icon-close"></i>
        </button>
      </div>
      <div class="wxpay-box-content">
        <div class="wxpayDiv" :class=" method === 0 ? '' : 'none-border'">
          <div class="wxpay-head" v-show="method === 0"></div>
          <div class="text-mony">￥{{wechatamount}}</div>
          <div class="wxpay-code">
            <div id="qrcode"></div>
            <!-- <img :src="src" style="width: 220px; height: 220px;" /> -->
          </div>
          <p
            style="font-size: 12px; line-height: 24px; color: rgb(102, 102, 102); padding-top: 12px;"
          >二维码有效时长为5分钟，请尽快支付！</p>
          <p
            style="font-size: 12px; line-height: 24px; color: rgb(215, 63, 68); padding-left: 46px;"
          >支付时请认准1778！</p>
        </div>
        <div class="wxpay-where" v-show="method === 0"></div>
      </div>
    </div>
    <div class="wxpay-box-bg-modal"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      qrCode: ""
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ""
    },
    wechatamount: {
      default: 0
    },
    method: {
      type:Number,
      required: true
    }
  },
  components: {
    QRCode
  },
  watch: {
    open() {
      if (this.open) {
        document.body.style = "overflow: hidden;";
        this.$nextTick(() => {
          this.qrCode = new QRCode("qrcode", {
            width: 220, //二维码的宽度
            height: 220, //二维码的高度
            text: this.src
          });
        });
      } else {
        document.body.style = "overflow: auto;";
      }
    }
  },
  methods: {
    // init() {
    //   this.qrCode =
    // },
    close() {
      document.body.style = "overflow: auto;";
      this.$emit("close", false);
    }
  },
  created() {
    // this.init()
  }
};
</script>

<style scoped>
.wxpay-box-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2000;
}
.wxpay-box-container::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}
.wxpay-box {
  display: inline-block;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 3px;
  font-size: 16px;
  overflow: hidden;
  text-align: left;
  backface-visibility: hidden;
  margin: auto;
}
.wxpay-box .wxpay-box-header {
  position: relative;
  padding: 20px 20px 0;
}
.wxpay-box .wxpay-box-header .wxpay-box-title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  color: #333;
}
.wxpay-box .wxpay-box-header .wxpay-box-header_headerbtn {
  position: absolute;
  top: 21px;
  right: 20px;
  background: 0 0;
  border: none;
  outline: 0;
  padding: 0;
  cursor: pointer;
}
.wxpay-box .wxpay-box-header .wxpay-box-header_headerbtn .wxpay-box-icon-close {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url(./close.png) no-repeat no-repeat;
  background-size: 100%;
}
.wxpay-box-content {
  padding: 30px 30px 60px;
  color: #48576a;
  font-size: 14px;
  position: relative;
}
.wxpayDiv {
  float: left;
  width: 286px;
  height: 100%;
  border-right: 1px dotted #e4e4e4;
  margin-right: 25px;
}
.none-border {
  border:none !important;
  margin: 0;
  width: auto;
}
.wxpay-head {
  width: 145px;
  height: 37px;
  margin: 0 0 15px 40px;
  background: url(./wxscan2.png) no-repeat;
}
.text-mony {
  font-size: 20px;
  width: 220px;
  color: red;
  text-align: center;
  margin-bottom: 10px;
  /* height: 220px; */
}
.wxpay-code {
  border: 1px solid #e4e4e4;
  width: 220px;
  height: 220px;
}
.wxpay-where {
  width: 190px;
  height: 296px;
  margin-left: 312px;
  background: url(./wxscan.png) no-repeat;
  background-position: 0px 0px;
}

.wxpay-box-bg-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/wxpay/index.vue